import React from "react";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";

import { Box, Button, Container, useTheme } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";

interface IProps {
  navigateToSearchPage: () => void;
}

export default function DesktopLowPriceHeader({
  navigateToSearchPage,
}: IProps) {
  const { palette, spacing } = useTheme();
  const { returnToSearch } = useTranslations().translations.lowPriceCalendar;

  return (
    <Box
      sx={{
        width: "100%",
        background: palette.primary.main,
        height: spacing(7),
        zIndex: 1,
      }}
    >
      <Container
        sx={{
          height: spacing(7),
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          variant="outlined"
          size="medium"
          color="white"
          onClick={navigateToSearchPage}
        >
          <ChevronLeftOutlinedIcon />
          {returnToSearch}
        </Button>
      </Container>
    </Box>
  );
}
